<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        @on-cancel="cancel"
        :mask-closable="false"
        @on-visible-change="openOrClose">

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="100">
        <FormItem label="广告位名称：" prop="ad_title">
            <Input type="text" v-model="formData.ad_title"></Input>
        </FormItem>
        <FormItem label="尺寸：" prop="ad_size">
            <Input type="text" placeholder="如：1000 x 450" v-model="formData.ad_size"></Input>
        </FormItem>

        <FormItem label="类型：" prop="type_id">
            <RadioGroup v-model="formData.type_id">
                <Radio label="1">
                    <span>图片</span>
                </Radio>
                <Radio label="2">
                    <span>代码/文字</span>
                </Radio>
            </RadioGroup>

        </FormItem>

        <FormItem label="排序：" prop="sort_num">
            <Input type="text" v-model="formData.sort_num"></Input>
        </FormItem>
        <FormItem label="状态：" prop="status">
            <RadioGroup v-model="formData.status">
                <Radio label="1">
                    <span>显示</span>
                </Radio>
                <Radio label="2">
                    <span>隐藏</span>
                </Radio>
            </RadioGroup>

        </FormItem>

        <FormItem>
            <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
        </FormItem>
    </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelect from '../common/searchSelect';
    export default {
        props:{
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        components: {
            SearchSelect,
        },
        data () {
            return {
                disabled:false,//禁用确定按钮
                word:'',//搜索商家的关键词
                title:'',//弹框标题
                formData: {//表单数据
                    id: '',
                    ad_title:'',
                    ad_size:'',
                    type_id:"1",
                    sort_num:"100",
                    status:"1",

                },
                ruleCustom: {//验证
                    ad_title: [
                        { required: true, message: '广告位名必须填写', trigger: 'blur' },
                        { min: 1, max: 100, message: '广告位名长度1 - 100', trigger: 'blur' }
                    ],
                    ad_size: [
                        { required: true, message: '广告位尺寸必须填写', trigger: 'blur' },
                        { min: 3, max: 100, message: '广告位尺寸长度3 - 100', trigger: 'blur' }
                    ],
                    type_id: [
                        { required: true, message: '广告位类型必须选择', trigger: 'blur' }
                    ],
                    sort_num: [
                        { required: true, message: '排序必须填写', trigger: 'blur' },
                        { min: 1, max: 10, message: '排序长度1 - 10', trigger: 'blur' }
                    ],
                    status: [
                        { required: true, message: '广告位状态必须选择', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            openOrClose(value){
                if(value === true){
                    if(this.type == 2){//编辑表单时，给表单赋值
                    this.formData.id = this.editFormData.id
                    this.formData.ad_title = this.editFormData.ad_title
                    this.formData.sort_num = this.editFormData.sort_num.toString()
                    this.formData.status = this.editFormData.status.toString()
                    this.formData.type_id = this.editFormData.type_id.toString()
                    this.formData.ad_size = this.editFormData.ad_size
                    }
                    this.title = this.type == 1?'添加广告位':'编辑广告位'
                }else{//关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            subData (name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        this.axios.post(this.config.urlArray.positionStore,this.formData).then((result) => {

                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                                },()=>{this.disabled = false;})

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                    }
                })
            },
            cancel () {//对话框关闭
                this.$emit('update:showModel',false)
            },
            resetForm () {//重置表单
                this.formData.id = ''
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
